export default [
  {
    component: () => import('./pages/Entry.vue'),
    meta: {
      metaTags: [
        {
          content: 'Turn your product photos into simple, eye-catching videos that build buyer trust and help your listings stand out.',
          name: 'description',
        },
        {
          page_slug: 'create-video',
        },
      ],
      requiresAuth: true,
      title: 'eRank — Create Video',
    },
    name: 'create-video',
    path: '/create-video',
  },
];
  